<template>
    <div v-if="applicationInitialized && userInitialized">
        <b-message v-if="messageIsVisible" title="Внимание!" type="is-danger" :closable="false"
                   aria-close-label="Close message">
            У вас есть не законченный тест.
            <router-link :to="{name: 'tests.show', params: {id: activeTest.id}}"> Продолжить тест</router-link>
        </b-message>

        <div class="has-background-light">
            <div class="has-background-dark">
                <div class="container is-widescreen px-3">
                    <navbar></navbar>
                </div>
            </div>
<!--            <div class="has-background-dark">-->
<!--                <div class="container is-widescreen px-3">-->
<!--                    РУР-->
<!--                </div>-->
<!--            </div>-->

            <section class="container is-widescreen box main-content">
                <router-view/>
            </section>
        </div>
    </div>
    <div v-else><b-loading :active="true" :is-full-page="true"></b-loading></div>
</template>
<style>
.main-content {
    min-height: calc(100vh - 52px );
}
</style>
<script>


import Navbar from './Navbar'
import { mapActions, mapGetters } from 'vuex'
import InitializeMixin from '@/mixins/InitializeMixin'

export default {
    mixins: [
        InitializeMixin,
    ],
    components: {
        Navbar,
    },
    methods: {
        ...mapActions({
            fetchActive: 'e/tests/fetchActive',
        }),
    },
    mounted () {
        if (this.$route.name !== 'tests.show') {
            this.fetchActive()
        }
    },
    computed: {
        ...mapGetters({
            activeTest: 'e/tests/activeTest',
            isLoaderActive: 'e/pages/isLoaderActive',
        }),
        messageIsVisible () {
            return this.$route.name !== 'tests.show' && !!this.activeTest && !this.activeTest.isFinished
        },
    },
}
</script>
